









import { Vue, Component, Prop } from "vue-property-decorator";

@Component({})
export default class PageHeader extends Vue {
  @Prop()
  readonly title: string;
}
